import Contact from './Contact';
import Note from './Note';
import TaxRegistration from './TaxRegistration';
import TradeLineItem from './TradeLineItem';
import { formatDate } from '@/utils';

export default class Invoice {
    constructor(data = {}) {
      console.log("TAXEXTEST",data.taxExemptionReasonCode)
      this.id = data.id || null;  // Add id field
      this.invoiceNumber = data.invoiceNumber || null;
      this.invoiceTypeId = data.invoiceTypeId || '0';
      this.typeId = data.typeId || '0';
      this.invoiceDate = formatDate(data.invoiceDate) || null;
      this.billingPeriodStart = formatDate(data.billingPeriodStart) || null;
      this.billingPeriodEnd = formatDate(data.billingPeriodEnd) || null;
      this.creationTimestamp = formatDate(data.creationTimestamp) || null;
      this.currencyCode = data.currencyCode || 'EUR';
      this.tradeLineItems = (data.tradeLineItems || []).map(item => item instanceof TradeLineItem ? item : new TradeLineItem(item));
      this.standardTaxRate = data.standardTaxRate !== undefined ? data.standardTaxRate : null;
      this.taxExemptionReasonCode = data.taxExemptionReasonCode || null;
      this.reducedTaxRate = data.reducedTaxRate !== undefined ? data.reducedTaxRate : null;
      this.sellerName = data.sellerName || null;
      this.sellerPostcode = data.sellerPostcode || null;
      this.sellerCity = data.sellerCity || null;
      this.sellerStreet = data.sellerStreet || null;
      this.sellerCountryCode = data.sellerCountryCode || 'DE';
      this.sellerGlobalID = data.sellerGlobalID || null;
      this.sellerGlobalIDSchemeIdentifier = data.sellerGlobalIDSchemeIdentifier || "0";
      this.sellerElectronicAddress = data.sellerElectronicAddress || null;
      this.buyerName = data.buyerName || null;
      this.buyerPostcode = data.buyerPostcode || null;
      this.buyerCity = data.buyerCity || null;
      this.buyerStreet = data.buyerStreet || null;
      this.buyerCountryCode = data.buyerCountryCode || 'DE';
      this.buyerGlobalID = data.buyerGlobalID || null;
      this.buyerGlobalIDSchemeIdentifier = data.buyerGlobalIDSchemeIdentifier || "0";
      this.buyerElectronicAddress = data.buyerElectronicAddress || null;
      this.iban = data.iban || null;
      this.bic = data.bic || null;
      this.bankName = data.bankName || null;
      this.paymentTerms = data.paymentTerms || null;
      this.buyerReference = data.buyerReference || null;
      this.businessProcess = data.businessProcess || null;
      this.notes = (data.notes || []).map(note => note instanceof Note ? note : new Note(note));
      this.sellerContact = data.sellerContact ? data.sellerContact instanceof Contact ? data.sellerContact : new Contact(data.sellerContact) : null;
      this.sellerTaxRegistrations = this.initTaxRegistrations(data.sellerTaxRegistrations);
      this.buyerTaxRegistrations = this.initTaxRegistrations(data.buyerTaxRegistrations);
      this.buyerContact = data.buyerContact ? data.buyerContact instanceof Contact ? data.buyerContact : new Contact(data.buyerContact) : null;
    }
  
    toJSON() {
      console.log('Serializing Invoice:', this);
      return {
        id: this.id,  // Include id in serialized output
        invoiceNumber: this.invoiceNumber,
        invoiceTypeId: this.invoiceTypeId,
        typeId: this.typeId,
        invoiceDate: this.invoiceDate,
        billingPeriodStart : this.billingPeriodStart,
        billingPeriodEnd : this.billingPeriodEnd,
        currencyCode: this.currencyCode,
        tradeLineItems: this.tradeLineItems.map(tradeLineItem => 
          tradeLineItem instanceof TradeLineItem ? tradeLineItem.toJSON() : new TradeLineItem(tradeLineItem).toJSON()
        ),
        standardTaxRate: this.standardTaxRate,
        taxExemptionReasonCode: this.taxExemptionReasonCode,
        reducedTaxRate: this.reducedTaxRate,
        sellerName: this.sellerName,
        sellerPostcode: this.sellerPostcode,
        sellerCity: this.sellerCity,
        sellerStreet: this.sellerStreet,
        sellerCountryCode: this.sellerCountryCode,
        sellerGlobalID: this.sellerGlobalID,
        sellerGlobalIDSchemeIdentifier: this.sellerGlobalIDSchemeIdentifier,
        sellerElectronicAddress: this.sellerElectronicAddress,
        buyerName: this.buyerName,
        buyerPostcode: this.buyerPostcode,
        buyerCity: this.buyerCity,
        buyerStreet: this.buyerStreet,
        buyerCountryCode: this.buyerCountryCode,
        buyerGlobalID: this.buyerGlobalID,
        buyerGlobalIDSchemeIdentifier: this.buyerGlobalIDSchemeIdentifier,
        buyerElectronicAddress: this.buyerElectronicAddress,
        iban: this.iban,
        bic: this.bic,
        bankName: this.bankName,
        paymentTerms: this.paymentTerms,
        buyerReference: this.buyerReference,
        businessProcess: this.businessProcess,
        notes: this.notes.map(note => 
          note instanceof Note ? note.toJSON() : new Note(note || {}).toJSON()
        ),
        sellerContact: this.sellerContact ? this.sellerContact instanceof Contact ? this.sellerContact.toJSON() : new Contact(this.sellerContact || {}).toJSON() : null,
        sellerTaxRegistrations: this.sellerTaxRegistrations.map(reg =>
            reg instanceof TaxRegistration ? reg.toJSON() : new TaxRegistration(reg || {}).toJSON()
        ),
        buyerTaxRegistrations: this.buyerTaxRegistrations.map(reg =>
            reg instanceof TaxRegistration ? reg.toJSON() : new TaxRegistration(reg || {}).toJSON()
        ),
        buyerContact: this.buyerContact ? this.buyerContact instanceof Contact ? this.buyerContact.toJSON() : new Contact(this.buyerContact || {}).toJSON() : null,
      };
    }

  // Add this helper method in the class
  initTaxRegistrations(data) {
    if (Array.isArray(data)) {
      return data.map(reg => reg instanceof TaxRegistration ? reg : new TaxRegistration(reg || {}));
    } else if (data && Object.keys(data).length > 0) {
      return [data instanceof TaxRegistration ? data : new TaxRegistration(data)];
    }
    return [];
  }

}
